import {axiosService} from "./axios.service";
import {endPoints} from "../configs/urls";

const cleanerService = {
    create: async (data) => {
        try {
            const res = await axiosService.post(endPoints.cleaner.base, data, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            return res;
        } catch (error) {
            throw error;
        }
    },
    getById: async (id) => {
        try {
            const res = await axiosService.get(`${endPoints.cleaner.base}${id}`);

            return res;
        } catch (error) {
            throw error;
        }
    },
    updateById: async (id, data) => {
        try {
            const res = await axiosService.patch(`${endPoints.cleaner.base}${id}/`, data);

            return res;
        } catch (error) {
            throw error;
        }
    },
}

export {
    cleanerService
}
